export default __webpack_public_path__ + "static/media/Walker's Boots of the Far Horizon.4a8e1e46.jpg";